// identity_icon：2  显示皇冠图标
// identity_icon：7  显示打钩图标
// identity_icon：3  显示推主图标
// identity_icon：1  显示开发者图标
<template>
  <div class="comment-item" v-if="itData">
    <div class="comment-fold" v-if="itData.fold_info&&itData.fold_info.fold_status!=0">
      <span @click="showFold()">该评价已被折叠</span>
    </div>
    <div v-else>
      <div class="item-head">
        <div class="uimg">
          <img :src="itData.user.avatar" alt="itData.user.nickname" />
        </div>
        <div class="uinfo">
          <div class="it-name">
            <em class="name">{{itData.user.nickname}}</em>
            <!-- 用户身份 -->
            <span class="up" v-if="itData.user.identity_icon==1">开发者</span>
            <span class="up" v-else-if="itData.user.identity_icon==3">推主</span>
            <span
              class="auth1"
              v-else-if="itData.user.identity_icon==7"
            >{{itData.user.identity_info}}</span>
            <span
              class="auth2"
              v-else-if="itData.user.identity_icon==2"
            >{{itData.user.identity_info}}</span>
          </div>
          <div class="it-time">
            <span :class="{'edit':itData.edittime>0}">{{itData.edittime>0?'修改于':''}}
              {{itData.time_str}}
            </span>          
          </div>
        </div>
      </div>
      <div class="item-score">
        <div class="starbar">
          <span :style="{width:starbar(itData.star/5)}"></span>
        </div>
        <span class="sp" v-if="itData.pub_game_status==4">期待值</span>
        <span class="sp" v-if="itData.is_pay==1">已购买</span>
        <span class="sp" v-if="itData.play_time">游戏时长 {{itData.play_time_str}}</span>
      </div>
      
      <div class="item-fold" v-if="itData.fold_info&&itData.fold_info.fold_status==0">
        折叠原因：{{itData.fold_info.fold_reason}}
        <a :href='rulelink(itData.fold_info.interface_info.interface_id)'>（规则说明）</a>        
      </div>
      <div class="item-text">
        <div
          class="txt"         
          ref="comtxt"
          @click="toView(itData.pid,itData.fid,itData.id)"
        >
          <img class="tag-bao" v-if="itData.user.user_tag&&itData.user.user_tag.icon_comment" :src="itData.user.user_tag.icon_comment" alt="">
          <span v-html="txtFilter(itData.content)"></span>
        </div>
        <span class="btn" @click="overShow" ref="showall">更多</span>
      </div>
      <div class="item-info">
        <span class="c-device">
          {{itData.user_agent}}
          {{ itData.location?' • '+itData.location:'' }}
        </span>
        <span @click="toReport">举报</span>
        <div class="fr">
          <span class="c-good" @click="popdown">{{itData.good>0?itData.good:''}}</span>
          <!-- <span class="c-bad" @click="popdown">{{itData.oppose>0?itData.oppose:''}}</span> -->
          <span class="c-reply" @click="toView(itData.pid,itData.fid,itData.id)">
            回复
            <i v-if="itData.posts>0">({{itData.posts | numFormat}})</i>
          </span>
        </div>
      </div>
      <!-- 回复 -->
 
      <div class="reply-it" v-if="replyFilter(itData.reply_list).length>0&&!isReco">
        <ul>
          <li v-for="(item,index) in replyFilter(itData.reply_list)" :key="index">
            <span class="name">
              <em 
                :class="{
                  'auth2':item.user.identity_icon=='2',
                  'auth1':item.user.identity_icon=='7'}"
                >
                  {{item.user.nickname}}
              </em>
              <span v-if="item.to_user">
                回复
                <em 
                  :class="{
                    'auth2':item.to_user.identity_icon=='2',
                    'auth1':item.to_user.identity_icon=='7'}"
                  >
                    {{item.to_user.nickname}}
                </em>
              </span>：
            </span>
            
            <span class="text" v-html="txtFilter(item.content)"></span>
          </li>
        </ul>
        <a
          class="reply-show"
          @click="toView(itData.pid,itData.fid,itData.id)"
          href="#"
        >查看全部{{itData.posts}}条回复</a>
      </div>
    </div>
  </div>
</template>

<script>
import Tool from "@/tool/tool";
export default {
  name: "Cstar",
  props: {
    itData: Object, //数据,
    isReco:{
      type:Boolean,
      default:false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setOver();
    });   
  },
  methods: {
    //过滤评论a标签 并保留文本
    txtFilter(str){
      //return str.replace(/(<\/?a.*?>)|(<\/?span.*?>)/g, '')
      return str.replace(/(<\/?a.*?>)/g, '')
    },
    replyFilter(arr){
      return arr.filter(item=>{
        return item.state>0
      })
    },
    rulelink(id){
      return "https://m.bbs.3839.com/thread-"+id+".htm"
    },
    starbar(num) {
      return Tool.ToolPercent(num);
    },
    //评论折叠显示
    showFold() {
      this.itData.fold_info.fold_status = 0;
      this.$nextTick(() => {
        this.setOver();
      }); 
    },
    setOver() {
      var temIt = this.$refs.comtxt;
      if(temIt){
        var temLH = Tool.getComLineHeight();
        if (temIt.offsetHeight > temLH * 4) {
          Tool.addClass(temIt, "over");
          temIt.nextElementSibling.style.display = "block";
        }
      }
    },
    //外部下载弹窗
    popdown() {
      window.comInit.downTips();
    },
    overShow(event) {
      var curIt = event.target;
      var curItPrev = Tool.siblings(event.target)[0];
      if (Tool.hasClass(curItPrev, "over")) {
        Tool.removeClass(curItPrev, "over");
        curIt.innerHTML = "收起";
      } else {
        Tool.addClass(curItPrev, "over");
        curIt.innerHTML = "更多";
      }
    },
    //评论详情
    toView(pid, fid, cid) {
      Tool.toView(pid, fid, cid);
    },
    //举报
    
    toReport(){
      let title = item_title || '快爆';
      let {content,user,id} = this.itData;
      if(content.length>180){
        content = Tool.cutstr(content,180)
      }
      switch (pid) {
        case 1:
          window.location.href=`//m.3839.com/report/?type=6&id=${id}&title=${title}&uimg=${(user.avatar).split('?')[0]}&uname=${user.nickname}&desc=${content}`;
          break;
        case 2:
          window.location.href=`//m.3839.com/report/?type=7&id=${id}&title=${title}&uimg=${(user.avatar).split('?')[0]}&uname=${user.nickname}&desc=${content}`;
          break;
        default:
          this.popdown()
          break;
      }
    },
    
  }
};
</script>


